import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IGetAllEstoqueControleUseCase } from "../../../presentation/useCases/read/get_all_controle_estoque_use_case";
import { IGetAllEstoqueSaidaUseCase } from "../../../presentation/useCases/read/get_all_sainda_use_case";
import { ControleEstoqueFilter } from "../../models/controle_estoque_filter";
import { ControleEstoque } from "../../models/controle_estoque_lista";
import { SaidaProdutosFilter } from "../../models/saida_produtos_filter";
import { SaidaProduto } from "../../models/saida_produtos_lista";
import { IEstoqueRepository } from "../../repositories/estoque_repository";


export class GetAllControleEstoqueUseCase
  extends BasePaginatedUseCase<ControleEstoque>
  implements IGetAllEstoqueControleUseCase {
  constructor(private readonly repository: IEstoqueRepository) {
    super();
  }

  async getAllListagemControle(
    filter: ControleEstoqueFilter,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {

    const response = await this.repository
      .getAllListagemControle(
        filter,
        page,
        rowsPerPage,
      );
    
    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }
}
